// Scheda prodotto nelle griglie del negozio (link interno al negozio)
import React from 'react';
import { Link } from 'react-router-dom';
import { Package, Star } from 'lucide-react';
import { optimizeImageUrl } from '../utils/imageUrl';
import { calculateFinalPrice, calculateFullPrice } from '../lib/feeCalculator';
import { getProductAvailability } from '../utils/productAvailability';
import { useShop } from './ShopContext';

export const productImage = (p, w = 600) =>
  optimizeImageUrl(p?.images?.[p?.customization_options?.main_image_index || 0] || p?.images?.[0], w);

export default function ShopProductCard({ product }) {
  const { style, paths, productReviews } = useShop();
  const img = productImage(product);
  // Seconda foto al passaggio del mouse (se c'è)
  const mainIdx = product.customization_options?.main_image_index || 0;
  const altSrc = (product.images || []).find((_, i) => i !== mainIdx);
  const alt = altSrc ? optimizeImageUrl(altSrc, 600) : null;
  const discount = product.customization_options?.crafterDiscount || 0;
  const full = calculateFullPrice(product.base_price);
  const price = calculateFinalPrice(product.base_price, discount);
  const { isAvailable } = getProductAvailability(product);
  const rev = productReviews[product.id];
  const centered = style.centered;

  return (
    <Link to={paths.product(product)} className={style.card} data-testid="shop-product-card">
      <div className={`${style.image} relative overflow-hidden bg-slate-100 ${style.radius}`}>
        {img ? (
          <>
            <img src={img} alt={product.title} loading="lazy" className={`w-full h-full object-cover transition-all duration-700 group-hover:scale-105 ${alt ? 'group-hover:opacity-0' : ''}`} />
            {alt && <img src={alt} alt="" aria-hidden loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-700 group-hover:opacity-100" />}
          </>
        ) : (
          <div className="w-full h-full flex items-center justify-center"><Package className="w-10 h-10 text-slate-300" /></div>
        )}
        {!isAvailable && (
          <span className="absolute top-2 left-2 text-[11px] font-semibold px-2 py-0.5 rounded bg-white/90 text-slate-700">Esaurito</span>
        )}
      </div>
      <p className={`${style.cardTitle} line-clamp-1`}>{product.title}</p>
      <div className={`flex items-center gap-2 ${style.cardMeta}`}>
        {discount > 0 && full !== price && <span className="text-xs text-slate-400 line-through">€{full.toFixed(2)}</span>}
        <span className={style.price}>€{price.toFixed(2)}</span>
        {rev && rev.count > 0 && !centered && (
          <span className="ml-auto inline-flex items-center gap-1 text-xs text-slate-500">
            <Star className="w-3.5 h-3.5 fill-shop-accent text-shop-accent" /> {rev.average.toFixed(1)}
          </span>
        )}
      </div>
    </Link>
  );
}
